<div class="cde-counter-down">
  <div class="cde-circle__wrapper cde-circle__wrapper--left">
    <div class="circle__whole circle__left"></div>
  </div>
  <div class="cde-circle__wrapper cde-circle__wrapper--right">
    <div class="circle__whole circle__right"></div>
  </div>
  <span class="time-left">{{ timeLeft() }}</span>
</div>
